function setCookie(cookieName, cookieValue, expirationDays) {
    var expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + expirationDays);
    // expirationDate.setTime(expirationDate.getTime() + (5 * 60 * 1000));
    var expires = "expires=" + expirationDate.toUTCString();
    document.cookie =
        cookieName + "=" + cookieValue + ";" + expires + ";path=/";
}
function getCookie(cookieName) {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();

        if (cookie.startsWith(cookieName + "=")) {
            return cookie.substring(cookieName.length + 1);
        }
    }

    return null;
}

function numberWithDots(x) {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");
}

function formatRupiah(money) {
    return new Intl.NumberFormat(
        "id-ID",
        { minimumFractionDigits: 0 } // diletakkan dalam object
    ).format(money);
}

//close input search
$(document).on("click", "#close-input-search", function () {
    $("#search-button").trigger("click");
});

// toggle filter
$(document).on("click", ".filter-toggle", function () {
    if ($(this).find("span").text() == "Hide") {
        $(this).find("span").text("Show");
    } else {
        $(this).find("span").text("Hide");
    }

    if (!window.matchMedia("(max-width: 750px)").matches) {
        $("#gf-products.row-collection").toggleClass("filter-toggle-active");

        var header_height = $("#shopify-section-header-2024").outerHeight();
        var window_height = $(window).height();
        var hasil_final = window_height - header_height - 120;

        // console.log('header_height', header_height)
        // console.log('window_height', window_height)

        if ($("#gf-products.row-collection").hasClass("filter-toggle-active")) {
            // console.log('#gf-products.row-collection', $('#gf-products.row-collection').attr('class'))
            // console.log('max-height', hasil_final + 'px')
            // $('.filter-sticky').css('max-height', hasil_final + 'px');
        } else {
            // console.log('#gf-products.row-collection', $('#gf-products.row-collection').attr('class'))
            // console.log('max-height', hasil_final + 'px')
            // $('.filter-sticky').css('max-height', '0px');
        }
    } else {
        // console.log('test')
        $(".filter-sticky .collection-sidebar-panel").toggleClass("active");
    }
});

function open_detail_order(id) {
    event.preventDefault();
    var awb = $("#awb-" + id).attr("data-id");
    let jsonData = {
        awb: awb,
        url_shopify: Shopify.shop,
    };

    var url =
        "https://atmos-custom-plugin-front.devbdd.com/api/customers/get_order_shipping";

    $.ajax({
        type: "POST",
        url: "https://atmos-custom-plugin-front.devbdd.com/api/customers/get_order_shipping",
        data: JSON.stringify({
            awb: awb,
            url_shopify: Shopify.shop,
        }),
        contentType: "application/json",
        dataType: "json",
        success: function (response) {
            //console.log(response); // Debugging to check structure

            // Step 1: Group data by date
            let groupedData = {};

            response.forEach((item) => {
                let [day, month, year, time] = item.date
                    .match(/(\d{2})-(\d{2})-(\d{4}) (\d{2}:\d{2})/)
                    .slice(1);
                let formattedDate = `${day}-${month}-${year}`; // Key for grouping

                if (!groupedData[formattedDate]) {
                    groupedData[formattedDate] = [];
                }

                groupedData[formattedDate].push({
                    time: time,
                    desc: item.desc,
                });
            });

            // Step 2: Append HTML
            let timelineContainer = $(".timeline");
            timelineContainer.empty(); // Clear existing content

            Object.keys(groupedData).forEach((dateKey) => {
                let entriesHtml = groupedData[dateKey]
                    .map(
                        (entry) => `
					<div class="entry">
						<span class="time">${entry.time}</span>
						<p>${entry.desc}</p>
					</div>
				`
                    )
                    .join("");

                let timelineItemHtml = `
					<div class="timeline-item">
						<div class="date">${formatDateToDay(dateKey)}<br><span>${dateKey}</span></div>
						<div class="line"></div>
						<div class="content">
							${entriesHtml}
						</div>
					</div>
				`;

                timelineContainer.append(timelineItemHtml);
            });
        },
        error: function (xhr, status, error) {
            console.log("Error:", error);
        },
    });

    $(".detail-summary").hide();
    $(".order-summary").removeClass("active");
    $(`#order-summary-${id}`).addClass("active");

    setTimeout(function () {
        var footerTop = $("#shopify-section-footer").offset().top;
        var detailSummary = $("#detail-summary-" + id);
        var detailBottom =
            detailSummary.offset().top + detailSummary.outerHeight();
        $("#detail-summary-" + id)
            .toggleClass("active")
            .slideToggle(200);

        if ($("#detail-summary-" + id).hasClass("active")) {
            if (detailBottom > footerTop) {
                var overlap = detailBottom - footerTop;
                detailSummary.css("top", -overlap - 200 + "px");
                $("html, body").animate(
                    {
                        scrollTop: detailSummary.offset().top,
                    },
                    500
                );
            } else {
                detailSummary.css("top", 0);
                $("html, body").animate(
                    {
                        scrollTop: detailSummary.offset().top - 200,
                    },
                    500
                );
            }
        } else {
            $("#detail-summary-" + id).hide();
        }
    }, 400);
}

function formatDateToDay(dateStr) {
    let [day, month, year] = dateStr.split("-");
    let dateObj = new Date(`${year}-${month}-${day}`);
    return dateObj.toLocaleDateString("en-US", { weekday: "long" });
}

function cancel_address_new() {
    $("#address-new").slideUp(300, function () {
        $(this).hide();
    });
    $(".add-new-address").show();
}

function add_new_address() {
    $("#address-new").slideDown(300, function () {
        $(this).show();
    });
    $(".add-new-address").hide();
}

function edit_address(id) {
    $(".customer-address-table").hide(); // Sembunyikan semua form edit
    $("#edit_address_" + id).slideUp(300, function () {
        $(this).show();
        $(".add-new-address").hide();
    });
    $(".addresses").css("display", "none");
}

function remove_edit_address(id) {
    $(".customer-address-table").hide(); // Sembunyikan semua form edit
    $("#edit_address_" + id).slideDown(300, function () {
        $(this).hide();
    });
    $(".add-new-address").show();
    $(".addresses").css("display", "block");
}

// header mega menu
function setMegaMenuHeight() {
    let headerHeight = $(".site-header").outerHeight();
    $(".MegaMenu").each(function () {
        $(this).css({
            // 'min-height': `calc(100vh - ${headerHeight}px)`,
            "max-height": `calc(100vh - ${headerHeight}px)`,
        });
    });

    let twoBannerHeight = headerHeight + 30;
    // $(".image-home-block").css("height", `calc(97vh - ${twoBannerHeight}px)`)
    // $(".video-home-block video").css("height", `calc(97vh - ${twoBannerHeight}px)`)
}

setMegaMenuHeight();
$(window).resize(function () {
    setMegaMenuHeight();
});

// :not(.menu-releases, .menu-brands)
$(".menu-desk .menu-item").on("mouseenter", function () {
    $("body").css("overflow", "auto").addClass("menu-opened");
    $(".MegaMenu").removeClass("show--mega-menu");

    if ($(this).find(".MegaMenu").length) {
        $(".menu-desk .menu-item.active").each(function () {
            $(this).removeClass("active");
        });

        $(this).addClass("active");
        $(this).find(".MegaMenu").addClass("show--mega-menu");
        $("body").css("overflow", "hidden");
    } else {
        $("body").removeClass("menu-opened");
    }
});

if ($(".MegaMenu.features").length) {
    var slider_features = $(".MegaMenu.features .features-imageList").slick({
        autoplay: false,
        speed: 500,
        arrows: false,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 1,
    });

    var scrollTimer;
    $(".MegaMenu.features .features-imageList").on("wheel", function (event) {
        if (event.originalEvent.deltaX !== 0) {
            event.preventDefault();

            if (scrollTimer) return;
            scrollTimer = setTimeout(() => {
                scrollTimer = null;
            }, 300);

            if (event.originalEvent.deltaX > 0) {
                slider_features.slick("slickNext");
            } else {
                slider_features.slick("slickPrev");
            }
        }
    });
}

$(".site-header").on("mouseleave", function () {
    if ($(".show--mega-menu").length) {
        $("body").css("overflow", "auto").removeClass("menu-opened");
        $(".MegaMenu").removeClass("show--mega-menu");
        $(".menu-desk .menu-item.active").each(function () {
            $(this).removeClass("active");
        });
    }
});
// end header mega menu

// collection ajaxinate
document.addEventListener("DOMContentLoaded", function () {
    if ("scrollRestoration" in history) {
        history.scrollRestoration = "manual";
    }

    // Init Ajaxinate
    if (document.querySelector("#collectionContainer #gf-products")) {
        new Ajaxinate({
            container: "#collectionContainer #gf-products",
            pagination: "#AjaxinatePagination",
            method: "click",
            offset: 1000,
        });
    }

    let restoreRunning = false;

    function restoreLastProductScroll() {
        if (restoreRunning) return;
        restoreRunning = true;

        // force always start from top (all devices)
        window.scrollTo(0, 0);

        const savedProductData = sessionStorage.getItem("lastProductData");
        if (!savedProductData) {
            restoreRunning = false;
            return;
        }

        let jsonData;
        try {
            jsonData = JSON.parse(savedProductData);
        } catch (e) {
            sessionStorage.removeItem("lastProductData");
            restoreRunning = false;
            return;
        }

        const product_handle = jsonData.product_handle;
        const collection_handle = jsonData.collection_handle;

        if (!product_handle || !collection_handle) {
            sessionStorage.removeItem("lastProductData");
            restoreRunning = false;
            return;
        }

        if (!location.href.includes(collection_handle)) {
            sessionStorage.removeItem("lastProductData");
            restoreRunning = false;
            return;
        }

        let attempts = 0;
        const maxAttempts = 10;

        const interval = setInterval(() => {
            const target = document.querySelector(`[data-handle="${product_handle}"]`);

            if (target) {
                clearInterval(interval);

                requestAnimationFrame(() => {
                    target.scrollIntoView({ behavior: "smooth", block: "center" });
                });

                sessionStorage.removeItem("lastProductData");
                restoreRunning = false;
                return;
            }

            const btn = document.querySelector("#AjaxinatePagination a");
            if (btn) {
                btn.click();
            }

            if (++attempts >= maxAttempts) {
                clearInterval(interval);
                sessionStorage.removeItem("lastProductData");
                restoreRunning = false;
            }
        }, 800);
    }

    // Run restore on normal load
    restoreLastProductScroll();

    // Run restore on back/forward cache (all devices)
    window.addEventListener("pageshow", function () {
        // delay to ensure DOM stable
        setTimeout(() => {
            restoreLastProductScroll();
        }, 300);
    });

    // Save last clicked product
    document.addEventListener("click", (e) => {
        const link = e.target.closest(".product-link");
        if (!link) return;

        const article = link.closest("[data-handle]");
        if (!article) return;

        const jsonData = {
            product_handle: article.dataset.handle,
            collection_handle: article.getAttribute("current-collection"),
        };

        sessionStorage.setItem("lastProductData", JSON.stringify(jsonData));
    });
});
// end collection ajaxinate

// lookbook ajaxinate
document.addEventListener("DOMContentLoaded", function () {
    var endlessScroll = new Ajaxinate({
        container: "#lookbook-list",
        pagination: "#lookbook-list-pagination",
        method: "scroll",
        offset: 1000,
    });
});
// end lookbook ajaxinate

// add class to body wishlist
if (window.location.href.includes("a/wishlist")) {
    $("body").addClass("template-wishlist");
}
// end add class

// js change wishlist
if (window.location.href.includes("a/wishlist")) {
    $(".wishlistpage .row .titletext").text("Wishlist");

    let check_wishlist_interval = setInterval(() => {
        if (
            $(
                "body.template-wishlist .wishlistpage .row.products #bookmarks .empty-wishlist"
            ).length
        ) {
            // let text_wishlist = "Your list is empty! Hit the [&#9825;] wishlist icon on any product to start building your list.";
            let text_wishlist =
                "No picks saved. Add your favorites <a href='/collections/new-arrivals'>here.</a>";
            $(
                "body.template-wishlist .wishlistpage .row.products #bookmarks .empty-wishlist"
            ).html(text_wishlist);
            clearInterval(check_wishlist_interval);
        } else if (
            $(
                "body.template-wishlist .wishlistpage .row.products #bookmarks .container-fluid"
            ).length
        ) {
            $(
                "body.template-wishlist .wishlistpage .row.products #bookmarks .container-fluid .row .col-md-4"
            ).each(function (i, v) {
                // append vendor product
                let product_handle = $(v)
                    .find(".product .image a")
                    .attr("href")
                    .split("?")[0];
                $.ajax({
                    type: "GET",
                    url: `${product_handle}.json`,
                    success: function (response) {
                        const product = response.product;
                        const product_vendor = product.vendor;

                        // replace new price
                        $(v)
                            .find(".product .text")
                            .prepend(
                                `<div class="product-vendor">${product_vendor}</div>`
                            );
                        $(v)
                            .find(".product .text")
                            // .append(
                            //     `<p class="price"> ${formatRupiah(
                            //         product.variants[0]["price"]
                            //     )}</p>`
                            // );
                            .append(
                                `<p class="price">₱${Number(product.variants[0]["price"]).toLocaleString('en-PH', {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0
                                })}</p>`
                            );
                    },
                    error: function (xhr, status, error) {
                        console.log(xhr.responseText);
                    },
                });

                // price change format
                // let price = $(v).find('p.price').attr('data-amount')
                // price = price.slice(0, -3)
                // price = numberWithDots(price)
                // $(v).find('p.price').html('IDR ' + price)

                // remove price from wishlist
                $(v).find(".product p .compare-price").remove();
                $(v).find(".product p .price").remove();

                //add button delete
                let pr_id_wishlist = $(v)
                    .find(".product")
                    .attr("data-productid");
                let var_id_wishlist = $(v)
                    .find(".product")
                    .attr("data-variantid");
                let pr_img_wishlist = $(v)
                    .find(".product .buttons a.singleremovebutton")
                    .attr("data-product_image");
                // console.log(pr_img_wishlist)
                let btn_delete =
                    '<button class="wishlist-btn-delete removebutton singleremovebutton" data-product_image="' +
                    pr_img_wishlist +
                    '" data-productid="' +
                    pr_id_wishlist +
                    '" data-variantid="' +
                    var_id_wishlist +
                    '"><img src="https://cdn.shopify.com/s/files/1/0259/7021/2909/files/material-symbols-light_delete-outline.svg?v=1721984259"></button>';
                $(v).find(".product").append(btn_delete);
            });
            clearInterval(check_wishlist_interval);
        }
    }, 0);
}

$(document).on("click", ".wishlist-btn-delete", function () {
    $(this)
        .closest(".product")
        .find(".singleremovebutton.removebutton")
        .trigger("click");
    let check_remove_modal_interval = setInterval(() => {
        if ($("#remove_modal").length) {
            $("#remove_modal .modal-body .remove-modal-description").remove();
            $("#remove_modal .modal-body .remove-modal-button").remove();

            let button_close = `
			<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z" fill="black"/>
			</svg>
			`;
            $("#remove_modal .modal-header button.close").html(button_close);

            let append_html = `
			<div class="remove-modal-description">
				You'll lost this item forever.
			</div>
			<div class="remove-modal-button">
				<button class="remove-button-agree">Agree</button>
				<button class="remove-button-back">Turning Back</button>
			</div>
			`;

            $("#remove_modal .modal-body #remove_modal_title").html(
                "Remove from Wishlist?"
            );
            $("#remove_modal .modal-body #remove_modal_title").after(
                append_html
            );
            $("#remove_modal .modal-body").prepend(
                $("#remove_modal .modal-header button.close")
            );

            clearInterval(check_remove_modal_interval);
        } else {
            $(this)
                .closest(".product")
                .find(".singleremovebutton.removebutton")
                .trigger("click");
        }
    }, 0);
});

$("#section-id-footer-product-slider .smartwishlist").each(function (i, v) {
    $(v).click(function (e) {
        e.preventDefault();
        const $product_handle = $(v).closest("article").attr("data-handle");
        const $product_id = $(v).attr("data-product");
        const $variant_id = $(v).attr("data-variant");

        if ($(this).hasClass("bookmarked")) {
            $(`#product_${$product_id}_${$variant_id}`)
                .find(".wishlist-btn-delete")
                .trigger("click");
        } else if ($(this).hasClass("unbookmarked")) {
            if (
                $(
                    "body.template-wishlist .wishlistpage .products>#bookmarks>.container-fluid>.row:not(.text-center) .empty-wishlist"
                ).length
            ) {
                $(
                    "body.template-wishlist .wishlistpage .products>#bookmarks>.container-fluid>.row:not(.text-center) .empty-wishlist"
                ).remove();
            }
            $.ajax({
                type: "get",
                url: `/products/${$product_handle}.js`,
                dataType: "json",
                success: function (product) {
                    const $wishlist_container = $(
                        "body.template-wishlist .wishlistpage .products>#bookmarks>.container-fluid>.row:not(.text-center)"
                    );
                    $wishlist_container.prepend(`
							<div class="col-md-4 col-sm-4" id="product_${$product_id}_${$variant_id}">
								<div class="product" data-productid="${$product_id}" data-variantid="${$variant_id}">
									<div class="image">
										<a href="${product.url}?variant=${$variant_id}">
											<img src="https:${product.featured_image}" alt="" class="img-responsive image1">
										</a>
									</div>
									<div class="text">
										<div class="product-vendor">${product.vendor}</div>
										<h3 class="product_title">
											<a href="${product.url}?variant=${$variant_id}">${product.title}</a>
										</h3>
										<p class="variant_title">${product.variants[0]["title"]}</p>
										<p class="price" data-amount="${product.price}">
                                            ₱${(product.price / 100).toLocaleString("en-PH", {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 0
                                            })}
                                        </p>
										<p class="buttons">
											<a role="button" tabindex="0" href="#" aria-label="Remove from Wishlist" class="btn btn-warning removebutton singleremovebutton" data-productid="${$product_id}" data-variantid="${$variant_id}" data-product_title="${
                        product.title
                    }" data-product_image="https:${
                        product.featured_image
                    }">Remove</a>
											<a role="button" tabindex="0" href="#" aria-label="Add to Shopping Cart" class="btn btn-primary addbutton addsingleproduct" data-productid="${$product_id}" data-variantid="${$variant_id}" data-variant_count="10" data-is_chosen_variant="0" data-url="${
                        product.url
                    }">
												<i class="fa fa-shopping-cart"></i>Add to Bag </a>
										</p>
									</div>
									<button class="wishlist-btn-delete removebutton singleremovebutton" data-product_image="https:${
                                        product.featured_image
                                    }" data-productid="${$product_id}" data-variantid="${$variant_id}">
										<img src="https://cdn.shopify.com/s/files/1/0259/7021/2909/files/material-symbols-light_delete-outline.svg?v=1721984259">
									</button>
								</div>
							</div>
						`);
                },
                error: function (error) {
                    console.error(error);
                },
            });
        }
    });
}); // Added a slight delay

$(document).on("click", ".remove-button-agree", function () {
    $(this)
        .closest(".modal-content")
        .find("#modal_remove_button")
        .trigger("click");
    const $empty_wishlist = $(
        "body.template-wishlist .wishlistpage .row.products #bookmarks .row:not(.text-center)"
    );
    const $text_wishlist =
        "Your list is empty! Hit the [&#9825;] wishlist icon on any product to start building your list.";
    const $ivt_wishlist = setInterval(() => {
        // console.log($empty_wishlist.find('div[class*="col-"]').length)
        if ($empty_wishlist.find('div[class*="col-"]').length == 0) {
            $empty_wishlist.append(`
				<div class="alert alert-info empty-wishlist">
					${$text_wishlist}
				</div>
			`);
        }
        clearInterval($ivt_wishlist);
    }, 0);
});

$(document).on("click", ".remove-button-back", function () {
    $(this)
        .closest(".modal-content")
        .find('button[data-dismiss="modal"]')
        .trigger("click");
});
// end js change wishlist

// if($("#open-voucher").length){
$(document).on("click", ".button-open-voucher", function () {
    let button_open = document.querySelector(".button-open-voucher");
    let envelope = document.querySelector(".open-voucher-here");
    let letter = document.querySelector(".open-voucher-here .letter p");
    let letter_message = document.querySelector(
        ".open-voucher-here .letter span"
    );
    let letter_info = document.querySelector(
        ".open-voucher-here .letter small"
    );
    let message = document.querySelector(".msg-res");

    function errorOpen(msg) {
        button_open.disabled = false;
        button_open.innerHTML = "atmos Summer Holigetaway";
        message.innerHTML = msg;
    }
    // button_open.addEventListener("click", () => {
    button_open.disabled = true;
    button_open.innerHTML = "Please Wait...";
    message.innerHTML = "";

    let cookie_voucher = getCookie("vcr");
    let show_voucher = cookie_voucher !== null ? false : true;
    show_voucher = true;

    setTimeout(() => {
        if (show_voucher) {
            fetch(
                "https://atmos-custom-plugin-front.devbdd.com/api/mystory_box?url_shopify=atmos-philippines-ph.myshopify.com",
                {
                    method: "GET",
                }
            )
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Error request: " + response.status);
                    }

                    return response.json();
                })
                .then((data) => {
                    envelope.classList.add("active");
                    letter.innerHTML = data.name;
                    letter_message.innerHTML = data.text;
                    letter_info.innerHTML = data.text2;
                    button_open.innerHTML = "Claim";
                    setCookie("vcr", "open", 1);

                    // change to claim
                    button_open.disabled = false;
                    $(".open-voucher-wrapper .main-button")
                        .removeClass("button-open-voucher")
                        .addClass("button-claim-voucher")
                        .attr("redirectto", data.redirect)
                        .attr("voucher", data.name);

                    // hide envelope
                    if (data.name == "FREESHOES") {
                        $(".wrapper").addClass("freeshoes");
                        $(".letter").append(`
              <a href="https://api.whatsapp.com/send/?phone=6285722505909&text&type=phone_number&app_absent=0" class="main-button button-freeshoes" target="_blank">
                <span class="bf-text">Chat with us</span>
                <span class="bf-image"><img src="https://cdn.shopify.com/s/files/1/0259/7021/2909/files/cs-atmos-removebg-preview.png?v=1694677682" class="rawa-svg"></span>
              </a>
            `);
                    }
                })
                .catch((error) => {
                    // console.error('Ada masalah dalam mengambil data:', error);
                    errorOpen("Something wrong, please refresh page");
                });
        } else {
            errorOpen("You have submitted previously");
        }
    }, 5000);
});
// }

$(document).on("click", ".button-claim-voucher", function () {
    let redirect_link = $(this).attr("redirectto");
    let voucher = $(this).attr("voucher");
    location.href = `https://${Shopify.shop}/discount/${voucher}?redirect=%2Fcollections%2F${redirect_link}`;
});

if (window.location.pathname.includes("collections")) {
    var min = $('input[name="filter.v.price.gte"]').val();
    if (min == "") {
        min = 0;
    }
    var max = $('input[name="filter.v.price.lte"]').val();
    if (max == "") {
        max = $('input[name="filter.v.price.gte"]').attr("max");
    }

    var fixed_max = $('input[name="filter.v.price.gte"]').attr("max");
    var parts = window.location.href.split("?")[0].split("/");
    var lastSegment = parts.pop() || parts.pop(); // handle potential trailing slash
    if ($(".filter-item.cat").length > 0) {
        if (
            $(".filter-item.cat").children(".filter-cat").data("value") ==
            lastSegment
        ) {
            $(".filter-item.cat")
                .children(".filter-cat")
                .data("value", lastSegment)
                .prop("checked", true)
                .attr("disabled", true);
        }
    }

    $(".filter-item.cat").click(function () {
        var click_value = $(this).children(".filter-cat").data("value");
        var new_url = lastSegment.replace(lastSegment, click_value);
        if (!$(this).children(".filter-cat").is(":checked")) {
            window.location.href = new_url;
        }
    });

    $(".filter-cat").change(function () {
        if (this.checked) {
            var click_value = $(this).data("value");
            var new_url = lastSegment.replace(lastSegment, click_value);
            window.location.href = new_url;
        }
    });

    $("#flat-slider").slider({
        orientation: "horizontal",
        range: true,
        animate: true,
        min: 0,
        max: Number(fixed_max),
        values: [Number(min), Number(max)],
        slide: function (event, ui) {
            if (ui.values[1] - ui.values[0] < 1) {
                return false;
            }

            $('input[name="filter.v.price.gte"]').val(ui.values[0]);
            $('input[name="filter.v.price.lte"]').val(ui.values[1]);
            window.location.href =
                window.location.href.split("?")[0] +
                "?filter.v.price.gte=" +
                ui.values[0] +
                "&filter.v.price.lte=" +
                ui.values[1];
        },
    });
}

$(".nama-brand").on("click", function () {
    $(".nama-brand").removeClass("active");
    $(".nama-brand[data-value=" + $(this).attr("data-value") + "]").addClass(
        "active"
    );
    $(".chart-detail").hide(500);
    $(".chart-detail." + $(this).attr("data-value")).show(500);
});

$(".chart-detail").hide(500);
$(".chart-detail.brand-Nike").show(500);

$(".select-nike").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Nike .kategori-sub").hide(500);
    $(".brand-Nike .kategori-sub." + valueSelected).show(500);
});

$(".select-jordan").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Jordan .kategori-sub").hide(500);
    $(".brand-Jordan .kategori-sub." + valueSelected).show(500);
});

$(".select-adidas").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Adidas .kategori-sub").hide(500);
    $(".brand-Adidas .kategori-sub." + valueSelected).show(500);
});

$(".select-new_balance").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-New_Balance .kategori-sub").hide(500);
    $(".brand-New_Balance .kategori-sub." + valueSelected).show(500);
});

$(".select-asics").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Asics .kategori-sub").hide(500);
    $(".brand-Asics .kategori-sub." + valueSelected).show(500);
});

$(".select-vans").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Vans .kategori-sub").hide(500);
    $(".brand-Vans .kategori-sub." + valueSelected).show(500);
});

$(".select-converse").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Converse .kategori-sub").hide(500);
    $(".brand-Converse .kategori-sub." + valueSelected).show(500);
});

$(".select-puma").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Puma .kategori-sub").hide(500);
    $(".brand-Puma .kategori-sub." + valueSelected).show(500);
});

$(".select-rebook").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Reebook .kategori-sub").hide(500);
    $(".brand-Reebook .kategori-sub." + valueSelected).show(500);
});

$(".select-hoka_one_one").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Hoka_One_One .kategori-sub").hide(500);
    $(".brand-Hoka_One_One .kategori-sub." + valueSelected).show(500);
});

$(".select-atmos").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Atmos .kategori-sub").hide(500);
    $(".brand-Atmos .kategori-sub." + valueSelected).show(500);
});

$(".select-88rising").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-88Rising .kategori-sub").hide(500);
    $(".brand-88Rising .kategori-sub." + valueSelected).show(500);
});

$(".select-herschel").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Herschel .kategori-sub").hide(500);
    $(".brand-Herschel .kategori-sub." + valueSelected).show(500);
});

$(".select-porter").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Porter .kategori-sub").hide(500);
    $(".brand-Porter .kategori-sub." + valueSelected).show(500);
});

$(".select-bearbrick").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Bearbrick .kategori-sub").hide(500);
    $(".brand-Bearbrick .kategori-sub." + valueSelected).show(500);
});

$(".select-carhartt").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Carhartt .kategori-sub").hide(500);
    $(".brand-Carhartt .kategori-sub." + valueSelected).show(500);
});

$(".select-huf").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Huf .kategori-sub").hide(500);
    $(".brand-Huf .kategori-sub." + valueSelected).show(500);
});

$(".select-the_north_face").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-The_North_Face .kategori-sub").hide(500);
    $(".brand-The_North_Face .kategori-sub." + valueSelected).show(500);
});

$(".select-jungles").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Jungles .kategori-sub").hide(500);
    $(".brand-Jungles .kategori-sub." + valueSelected).show(500);
});

$(".select-babylon").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Babylon .kategori-sub").hide(500);
    $(".brand-Babylon .kategori-sub." + valueSelected).show(500);
});

$(".select-domestik").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Domestik .kategori-sub").hide(500);
    $(".brand-Domestik .kategori-sub." + valueSelected).show(500);
});

$(".select-g-shock").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-G-shock .kategori-sub").hide(500);
    $(".brand-G-shock .kategori-sub." + valueSelected).show(500);
});

$(".select-nothing").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Nothing .kategori-sub").hide(500);
    $(".brand-Nothing .kategori-sub." + valueSelected).show(500);
});

$(".select-stance").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Stance .kategori-sub").hide(500);
    $(".brand-Stance .kategori-sub." + valueSelected).show(500);
});

$(".select-crep_Protect").on("change", function (e) {
    var optionSelected = $("option:selected", this);
    var valueSelected = this.value;

    $(".brand-Crep_Protect .kategori-sub").hide(500);
    $(".brand-Crep_Protect .kategori-sub." + valueSelected).show(500);
});

if (window.location.href.includes("/account?view=edit")) {
    $(
        `<a href="/account" style="display : block; margin-top : 1em;">&larr; Return to account page</a>`
    ).insertAfter(".form-vertical");
}

if (window.location.href.includes("notify-me")) {
    const formatPrice = (price) => {
        return new Intl.NumberFormat("id-ID", {
            minimumFractionDigits: 0, // Menghilangkan desimal
            maximumFractionDigits: 0, // Menghilangkan desimal
        }).format(price);
    };

    function toCapitalize(text) {
        text =
            text.toLowerCase().charAt(0).toUpperCase() +
            text.toLowerCase().slice(1);
        return text;
    }

    var cust_notify = $(".cust_email_notify").val();

    const formData = new FormData();
    formData.append("email_customer", cust_notify);
    formData.append("url_shopify", Shopify.shop);

    $.ajax({
        type: "POST",
        url: "https://notify-general.shopify-plugin.devbdd.com/get_products",
        data: formData,
        dataType: "text",
        cache: false,
        contentType: false,
        crossDomain: true,
        processData: false,
        success: function (response) {
            let result = JSON.parse(response);
            let products_html = "";

            // console.log(response)

            result.forEach((data) => {
                let cap_html = ``;
                let price = data.price * 1;
                let compare_at_price = data.compare_at_price * 1;
                if (compare_at_price > price) {
                    cap_html += `
						<span class="down-from-price"> IDR ${formatPrice(compare_at_price)} </span>
					`;
                }

                products_html += `
					<div class="this column-block notify-product-item status-${data.status}">
						<article class="product grid-item slider-item collection-item " data-handle="${
                            data.product_handle
                        }" style="position: relative">
							<div>
								<div class="product-featured-image">
									<a href="/products/${data.product_handle}">
										<img src="${data.product_image}" width="" height="">
									</a>
								</div>
								
								<h4 class="product-brand">
									<a href="/collections/footwear?filter.p.vendor=${
                                        data.product_vendor
                                    }&filter.v.availability=1">${toCapitalize(
                    data.product_vendor
                )}</a>
								</h4>
								<a href="/products/${data.product_handle}">
									<h4 class="product-title">${toCapitalize(data.product_name)}</h4>
									<div class="product-price__wrapper">
										<div class="product-price  "> IDR ${formatPrice(price)} </div>
										${cap_html}
									</div>
								</a>
							</div>
						</article>
					</div>
				`;
            });

            $(".list-products__notify .row").html(products_html);
        },
        error: function (response) {
            console.log(response);
        },
    });
}

if ($("#bdd-notify-v2, .product.grid-item").length) {
    $(document).on(
        "click",
        "#button-notify, .close-notify, #button-notify-quick, .notify-v2-overlay",
        function () {
            $(".notify-v2-overlay, .notify-v2-popup").toggleClass("active");

            if (window.matchMedia("(max-width: 750px)").matches) {
                $('.notify-v2-form-detail-mobile').append($('.notify-v2-form-detail-inner'))
            }
            else {
                $('.notify-v2-form-detail-desktop').append($('.notify-v2-form-detail-inner'))
            }

            $('.quickbuy-modal.in-product-page').removeClass('show')
            $('.cart-select-size-modal').removeClass('show')

            if ($(".notify-v2-popup").hasClass("after-submit")) {
                setTimeout(() => {
                    $(".notify-v2-popup").removeClass("after-submit");
                    $(".notify-v2-popup__content h2").html(
                        `Back In Stock Alert`
                    );
                    $(".notify-v2-popup__content form input").val("");
                    $(".notify-v2-popup__content form").show();
                    $(".notify-v2-popup__content button-after-submit").hide();
                }, 1000);
            }
        }
    );

    $(document).on("submit", ".notify-v2-popup__content form", function (e) {
        e.preventDefault();
        var url =
            "https://notify-general.shopify-plugin.devbdd.com/config/simpanCustomer";
        const formData = new FormData(this);
        formData.append("url_shopify", Shopify.shop);
        let data_size = $(this).attr('data-size');

        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            dataType: "text",
            cache: false,
            contentType: false,
            crossDomain: true,
            processData: false,
            beforeSend: function () {
                $(".notify-v2-popup form .main-button").text("Pleas Wait ...");
                $(".notify-v2-popup form .main-button").attr(
                    "disabled",
                    "disabled"
                );
            },
            success: function (response) {
                if (response == 200) {
                    $(".notify-v2-popup form .main-button").text("Submit");
                    $(".notify-v2-popup form .main-button").attr("disabled", false);

                    $(".notify-v2-popup form").hide();
                    $(".notify-v2-popup .button-after-submit").show();
                    
                    $(".notify-v2-popup").addClass("after-submit");
                    $(".notify-v2-popup__content > h2").html(
                        `Locked in.`
                    );

                    $(".notify-v2-popup .description-after-submit").html(
                        `We’ll ping you as soon as size ${data_size} is back in stock.`
                    );
                } else {
                    $(".info-message").html("Something wrong, try again.");
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            },
            error: function (response) {
                alert("Something wrong, Please refresh page.");
            },
        });
    });
}

// if($(".template-product").length){
// 	if (window.matchMedia('(max-width: 641px)').matches) {
// 		$(".product-promises").after($(".estimate-shipping-column"))
// 	}
// }

var kolom_length = $(".kolom-produk").length;
if (kolom_length == 1) {
    // $('.kolom-produk').addClass('nambah-gede');
}
var announcement_height = $("#shopify-section-announcement").outerHeight();
$(window).scroll(function () {
    if ($(this).scrollTop() > announcement_height) {
        $("div#shopify-section-header").addClass("bdd-sticky");
        $(".cart-panel .footer-container").removeClass("cart-on-top");
        $("#toTop").show();
    } else {
        $("div#shopify-section-header").removeClass("bdd-sticky");
        $(".cart-panel .footer-container").addClass("cart-on-top");
        $("#toTop").hide();
    }
});

url = window.location.href;
is_product = url.match(/.*\/products\/.*/);
if (window.location.href.includes("collections")) {
    if (!$("body").hasClass("template-new-upcoming")) {
        if (is_product == null) {
            // document.querySelector('#SortBy').addEventListener('change', function () {
            // 	const urlSearchParams = new URLSearchParams(window.location.search);

            // 	urlSearchParams.set(this.name, this.value);

            // 	window.location = `?${urlSearchParams}`;
            // });

            $(document).on("click", ".filter-sort input", function () {
                const paramKey = "sort_by"; // Key for the query parameter
                const paramValue = $(this).val(); // Desired value for the parameter
                const url = new URL(window.location.href);

                if ($(this).is(":checked")) {
                    // Add or update the parameter if the input is checked
                    if (!url.searchParams.has(paramKey)) {
                        url.searchParams.append(paramKey, paramValue);
                    } else {
                        url.searchParams.set(paramKey, paramValue);
                    }
                } else {
                    // Remove the parameter if the input is unchecked
                    url.searchParams.delete(paramKey);
                }

                // Update the URL and reload the page
                window.location.href = url.toString();
            });

            $(".size-digit-kebawah").appendTo(".2digit_kebawah");
            $(".size-digit-keatas[data-sort-type=UK]").appendTo(".type-uk");
            $(".size-digit-keatas[data-sort-type=US]").appendTo(".type-us");
            $(".size-digit-keatas[data-sort-type=EUR]").appendTo(".type-eur");

            function sortEm(a, b) {
                return parseInt($(a).attr("data-sort-nomor")) >
                    parseInt($(b).attr("data-sort-nomor"))
                    ? 1
                    : -1;
            }
            $(".type-uk li").sort(sortEm).prependTo($(".type-uk"));
            $(".type-us li").sort(sortEm).prependTo($(".type-us"));
            $(".type-eur li").sort(sortEm).prependTo($(".type-eur"));

            var announce_height = $(
                "#shopify-section-announcement"
            ).outerHeight();
            var header_height = $("#shopify-section-header-2024").outerHeight();
            var headerc_height = $(".collection-header").outerHeight();

            // console.log('announce_height', announce_height)
            // console.log('header_height', header_height)
            // console.log('headerc_height', headerc_height)

            var hasil_gabungan = announce_height + headerc_height;
            var window_height = $(window).height();

            var hasil_final = window_height - header_height - 120;
            var hasil_mobile_lebih = header_height + headerc_height;
            var hasil_mobile_kurang =
                announce_height + header_height + headerc_height;

            $(".filter-sticky .panel").css("top", hasil_mobile_kurang + "px");

            $(window).scroll(function () {
                if ($(this).scrollTop() > hasil_gabungan) {
                    $(".filter-sticky").addClass("is-sticky");
                    $(".filter-sticky.is-sticky").css(
                        "top",
                        header_height + "px"
                    );
                    if (
                        $("#gf-products.row-collection").hasClass(
                            ".filter-toggle-active"
                        )
                    ) {
                        // $('.filter-sticky.is-sticky').css('max-height', hasil_final + 'px');
                    }
                } else {
                    $(".filter-sticky").removeClass("is-sticky");
                }

                if ($(this).scrollTop() > announce_height) {
                    $(".filter-sticky .panel").css(
                        "top",
                        hasil_mobile_lebih + "px"
                    );
                } else {
                    $(".filter-sticky .panel").css(
                        "top",
                        hasil_mobile_kurang + "px"
                    );
                }
            });
        }
    }
} else if (window.location.href.includes("search")) {
    if (is_product == null) {
        $(document).on("click", ".filter-sort input", function () {
            const paramKey = "sort_by"; // Key for the query parameter
            const paramValue = $(this).val(); // Desired value for the parameter
            const url = new URL(window.location.href);

            if ($(this).is(":checked")) {
                // Add or update the parameter if the input is checked
                if (!url.searchParams.has(paramKey)) {
                    url.searchParams.append(paramKey, paramValue);
                } else {
                    url.searchParams.set(paramKey, paramValue);
                }
            } else {
                // Remove the parameter if the input is unchecked
                url.searchParams.delete(paramKey);
            }

            // Update the URL and reload the page
            window.location.href = url.toString();
        });

        $(".size-digit-kebawah").appendTo(".2digit_kebawah");
        $(".size-digit-keatas[data-sort-type=UK]").appendTo(".type-uk");
        $(".size-digit-keatas[data-sort-type=US]").appendTo(".type-us");
        $(".size-digit-keatas[data-sort-type=EUR]").appendTo(".type-eur");

        function sortEm(a, b) {
            return parseInt($(a).attr("data-sort-nomor")) >
                parseInt($(b).attr("data-sort-nomor"))
                ? 1
                : -1;
        }
        $(".type-uk li").sort(sortEm).prependTo($(".type-uk"));
        $(".type-us li").sort(sortEm).prependTo($(".type-us"));
        $(".type-eur li").sort(sortEm).prependTo($(".type-eur"));

        var announce_height = $("#shopify-section-announcement").outerHeight();
        var header_height = $("#shopify-section-header-2024").outerHeight();
        var headerc_height = $(".collection-header").outerHeight();

        // console.log('announce_height', announce_height)
        // console.log('header_height', header_height)
        // console.log('headerc_height', headerc_height)

        var hasil_gabungan = announce_height + headerc_height;
        var window_height = $(window).height();

        var hasil_final = window_height - header_height - 120;
        var hasil_mobile_lebih = header_height + headerc_height;
        var hasil_mobile_kurang =
            announce_height + header_height + headerc_height;

        $(".filter-sticky .panel").css("top", hasil_mobile_kurang + "px");

        $(window).scroll(function () {
            if ($(this).scrollTop() > hasil_gabungan) {
                $(".filter-sticky").addClass("is-sticky");
                $(".filter-sticky.is-sticky").css("top", header_height + "px");
                if (
                    $("#gf-products.row-collection").hasClass(
                        ".filter-toggle-active"
                    )
                ) {
                    // $('.filter-sticky.is-sticky').css('max-height', hasil_final + 'px');
                }
            } else {
                $(".filter-sticky").removeClass("is-sticky");
            }

            if ($(this).scrollTop() > announce_height) {
                $(".filter-sticky .panel").css(
                    "top",
                    hasil_mobile_lebih + "px"
                );
            } else {
                $(".filter-sticky .panel").css(
                    "top",
                    hasil_mobile_kurang + "px"
                );
            }
        });
    }
}

$(document).on("click", "#cart-panel-custom .close-button", function (e) {
    e.preventDefault();
    $("#cart-panel-custom").removeClass("active");
    $("#cart-panel-custom").addClass("hide-transition");

    setTimeout(function () {
        $("#cart-panel-custom").remove();
    }, 1000);
});

$(".voucher-claim").click(function () {
    const element = $(this).attr("data-copy");
    const storage = document.createElement("textarea");
    storage.value = element;
    $(".voucher-container").append(storage);

    storage.select();
    storage.setSelectionRange(0, 99999);
    document.execCommand("copy");
    $(".voucher-container textarea").remove();

    $(this).html("Copied!");
    // console.log(element)
    return false;
});

if ($("div#voucher-wrapper").length > 0) {
    let getIdGroup = $("#voucher-wrapper").attr("group");
    let getIdCustomer = $(".get-customer-information").attr("customer-id");
    let currentUrl = window.location.href;
    let getUrlStore = $("#voucher-wrapper").attr("url-shopify");
    let titlePage = $(".get-customer-information").attr("page-title");

    $.ajax({
        type: "POST",
        url: "https://atmos-custom-plugin.devbdd.com/front/display_list_voucher",
        data: {
            id: getIdGroup,
            customerId: getIdCustomer,
            currentUrl: currentUrl,
            url_shopify: getUrlStore,
            titlePage: titlePage,
        },
        success: function (response) {
            $("#voucher-wrapper").append(response);
            if (currentUrl.includes("claim=failed")) {
                $("#voucher-wrapper").prepend(
                    '<div class="voucher-wrappe-failed">Claim voucher failed, please <a href="/account/login">login here.</a></div>'
                );
            }

            let content_mystery_box = `
        <div class="open-voucher-wrapper">
          <div class="open-voucher-content">
            <div class="wrapper open-voucher-here">
              <div class="lid one"></div>
              <div class="lid two"></div>
              <div class="envelope"></div>
              <div class="letter">
                <p></p>
                <span></span>
                <small></small>
              </div>
            </div>

            <button class="main-button button-open-voucher">atmos Summer Holigetaway</button>
            <div class="msg-res"></div>
          </div>
        </div>
      `;

            if (window.matchMedia("(min-width: 751px)").matches) {
                //$("#voucher-wrapper").append(content_mystery_box);
            } else {
                //$("#voucher-wrapper").prepend(content_mystery_box);
            }
        },
    });
}

if ($("body").hasClass("template-upcoming")) {
    $(document).on("click", "#openForm", function (e) {
        e.preventDefault();
        $("body").css("overflow", "hidden");
        $(".popup-form").show();
        $(".upcoming-floating").addClass("hidefloating");
    });

    $(document).on("click", ".form-close .close", function (e) {
        e.preventDefault();
        $("body").css("overflow", "");
        $(".popup-form").hide();
        $(".upcoming-floating").removeClass("hidefloating");
    });

    $("#enterForm").on("click", function (e) {
        e.preventDefault();
        // console.log(e);
        $("body").css("overflow", "hidden");
        $(".popup-form").show();
        $(".upcoming-floating").addClass("hidefloating");
    });

    function showFloatingDraw() {
        const floatingElement = document.querySelector(".upcoming-floating");
        if (window.scrollY > 300) {
            floatingElement.style.transform = "translateY(0)";
        } else {
            floatingElement.style.transform = "";
        }
    }

    window.addEventListener("scroll", showFloatingDraw);
    window.addEventListener("load", showFloatingDraw);

    $(".form-product-register").on("submit", function (e) {
        e.preventDefault();
        let url =
            "https://atmos-custom-plugin-front.devbdd.com/api/customers/submit";
        let name = $("[name=name]").val() ? $("[name=name]").val() : "";
        let email = $("[name=email]").val() ? $("[name=email]").val() : "";
        let phone = $("[name=phone]").val() ? $("[name=phone]").val() : "";
        let product_id = $("#product_id").val();

        let jsonData = {
            url_shopify: Shopify.shop,
            id_form: 2,
            ktp: 0,
            receipt_number: 0,
            product: product_id,
            name: name,
            email: email,
            phone: phone,
            ig: null,
            shoe_size: null,
            address: null,
            birtday: null,
        };

        // console.log(jsonData);

        $.ajax({
            url: "https://atmos-custom-plugin-front.devbdd.com/api/customers/submit",
            type: "POST",
            data: jsonData, // Include data in the request
            dataType: "json",
            crossDomain: true, // Enable CORS
            beforeSend: function () {
                $(".form-content-submit .form-submit")
                    .html(`Loading...`)
                    .attr("disabled", "disabled");
            },
            success: function (data) {
                $(".form-content-submit .form-submit")
                    .html(`Submit`)
                    .removeAttr("disabled");
                let result = data.response;

                if (result["status"] == "200") {
                    // alert("Successfully submitted");
                    $(".form-response")
                        .html("Thankyou for your submit.")
                        .css("text-align", "center");
                    // location.reload();
                } else {
                    alert("Already submitted");
                }
            },
            error: function (xhr, status, error) {
                console.log(error, xhr, status);
            },
        });
    });
}
// function open sidebar menu
$("#new-main-nav-toggle").click(function (e) {
    if ($(this).attr("aria-click") == "false") {
        // console.log('opened');
        $(this).attr("aria-click", "true");
        $("#atmos-sidebar").attr("aria-sidebar", "opened");
        // $('#close-container-drawer').attr('aria-sidebar', 'opened');
        // $('.body-overlay').addClass('is-visible');
        $("body").attr("style", "overflow: hidden;");
        $(".filter-sticky").css("z-index", "1");
        let check_search = $(".search-panel");
        if (!check_search.hasClass("active")) {
        } else {
            $(".search-panel").removeClass("active");
            $("#close-container-drawer-filter").trigger("click");
            $(".collection-sidebar-panel.hide-mobile").removeClass("active");
        }
    } else {
        // console.log('closed');
        $("#atmos-sidebar").attr("aria-sidebar", "closed");
        $("#close-container-drawer").attr("aria-sidebar", "closed");
        $("#new-main-nav-toggle").attr("aria-click", "false");
        $('.cart-sidebar').removeClass('show')
        // $('.body-overlay').removeClass('is-visible');
        $("body").attr("style", "");
        setTimeout(() => {
            $(".filter-sticky").css("z-index", "");
        }, 500);
    }
});

// function close sidebar menu
$("#close-sidebar").click(function (e) {
    if ($(this).attr("aria-click") == "false") {
        // console.log('closed');
        $("#atmos-sidebar").attr("aria-sidebar", "closed");
        $("#close-container-drawer").attr("aria-sidebar", "closed");
        $("#new-main-nav-toggle").attr("aria-click", "false");
        // $('.body-overlay').removeClass('is-visible');
        $("body").attr("style", "");
        setTimeout(() => {
            $(".filter-sticky").css("z-index", "");
        }, 500);
    }
});
$(document).on("click", ".cancel-filter", function () {
    $("#close-container-drawer-filter").trigger("click");
});

$(".sidebar-collapsible--button").click(function (e) {
    e.preventDefault();
    let panel = this.nextElementSibling;
    if ($(this).attr("aria-expanded") == "false") {
        $(this).attr("aria-expanded", "true");
        if (!panel.style.maxHeight) {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    } else {
        $(this).attr("aria-expanded", "false");
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        }
    }
});

let header_href = $(".site-header.small--hide.tablet--hide").find("a");
let drawer_href = $(".atmos-drawer .sidebar-menu--nav").find("a");
let footer_href = $(".footer-navigation .column-nav .menu-item").find("a");

// header desktop

for (let z = 0; z < header_href.length; z++) {
    let url_href = $(header_href[z]).attr("href");
    // console.log(url_href);
    if (url_href != "/collections/new-arrivals") {
        if (!url_href.includes("?")) {
            if (
                url_href.indexOf("#") === -1 &&
                url_href.indexOf("/pages") === -1 &&
                url_href.indexOf("raffle") === -1
            ) {
                header_href[z].href += "?filter.v.availability=1";
            }
        }
    }
}

// footer
for (let z = 0; z < footer_href.length; z++) {
    let footer_url_href = $(footer_href[z]).attr("href");
    if (footer_url_href != "/collections/new-arrivals") {
        if (!footer_url_href.includes("?")) {
            if (
                footer_url_href.indexOf("#") === -1 &&
                footer_url_href.indexOf("/pages") === -1 &&
                footer_url_href.indexOf("raffle") === -1
            ) {
                footer_href[z].href += "?filter.v.availability=1";
            }
        }
        if (footer_url_href.includes("?page=1")) {
            let split_href = footer_url_href.split("?");
            let new_split_href =
                (split_href[0] += `?filter.v.availability=1&${split_href[1]}`);
            $(footer_href[z]).attr("href", new_split_href);
        }
    }
}

// drawer mobile
for (let z = 0; z < drawer_href.length; z++) {
    let drawer_url_href = $(drawer_href[z]).attr("href");
    if (drawer_url_href != "/collections/new-arrivals") {
        if (!drawer_url_href.includes("?")) {
            if (
                drawer_url_href.indexOf("#") === -1 &&
                drawer_url_href.indexOf("/pages") === -1 &&
                drawer_url_href.indexOf("raffle") === -1
            ) {
                drawer_href[z].href += "?filter.v.availability=1";
            }
        }
    }
}

(function ($) {
    // new product detail page 2024
    $("#decrease-qty, #increase-qty").click(function (e) {
        e.preventDefault();

        let current_qty = parseInt($("#quantity-input").val());
        
        if ($(this).html().trim() == "<span>+</span>") {
            current_qty++;
        } else if ($(this).html().trim() == "<span>-</span>") {
            current_qty = Math.max(current_qty - 1, 0);
        }
        
        if (current_qty <= 1) {
            $("#quantity-input").val(1);
            $("#decrease-qty").attr('disabled', 'disabled');
        } else {
            $("#quantity-input").val(current_qty);
            $("#decrease-qty").removeAttr('disabled');
        }
    });
    function PdpAddToCartDrawer() {
        let cart_section_drawer_str =
            '<section id="cart-panel-custom" class="cart-panel panel hide-transition"><div class="cart"><div class="row"><div class="small-8 columns small-push-2"><h3 class="panel-title">Cart</h3></div><div class="small-2 columns text-right"><button type="button" class="close-button"><i class="fa fa-times"></i></button></div></div><div class="scroll-container"><div class="row"><div class="small-12 columns" id="product-line-items"></div></div></div><div class="footer-container"><div class="row columns"><div id="total-line-items"><div class="cart-total"></div><a href="/checkout" id="checkout-button" class="main-button">Checkout</a></div><button type="button" class="secondary-button continue-shop">Continue shopping</button></div></div></div></section>';

        let product_line_item_str =
            '<article class="product-line-item"><div class="row"><div class="small-4 medium-3 columns"><img src="" class="product-image" alt=""></div><div class="small-8 medium-9 columns"><h4 class="product-title"></h4><div class="product-price"></div></div></div><div class="row"><div class="small-12 medium-12 columns"><div class="product-size"></div></div><div class="small-4 medium-6 columns"><div class="product-quantity"><div class="quantity-button reduce text-left"><button type="button"><i class="fa fa-minus-circle fa-sm"></i></button></div><div class="quantity-button quantity text-center"></div><div class="quantity-button add text-right"><button type="button"><i class="fa fa-plus-circle fa-sm"></i></button></div></div></div></div></article>';

        let cart_section_drawer = jQuery(cart_section_drawer_str);
        let product_line_item = jQuery(product_line_item_str);
        let total = 0;

        jQuery.ajax({
            type: "GET",
            url: "/cart.js",
            cache: false,
            dataType: "json",
            success: function (cart) {
                let cart_quantity_indicator = $(
                    "#cart-quantity-indicator"
                ).html();
                if (cart_quantity_indicator == "") {
                    $("#cart-quantity-indicator").show();
                    cart_quantity_indicator = "0";
                }
                cart_quantity_indicator = parseInt(cart_quantity_indicator) + 1;
                $("#cart-quantity-indicator").html(cart_quantity_indicator);

                // jQuery.each(cart.items, function (i, v) {
                // 	// console.log(v);

                // 	let temp = product_line_item.clone();
                // 	let final_price = '' + v.final_price;
                // 	final_price = final_price.substring(0, final_price.length - 2);
                // 	final_price = final_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

                // 	temp.find('img.product-image').prop('src', v.featured_image.url);
                // 	temp.find('img.product-image').prop('alt', v.title);
                // 	temp.find('h4.product-title').html(v.title);
                // 	temp.find('.product-price').html('IDR ' + final_price);
                // 	temp.find('.product-size').html(v.options_with_values[0].value + ' / ' + v.options_with_values[1].value);
                // 	temp.find('.quantity-button.quantity').html(v.quantity);
                // 	total += v.final_price;

                // 	jQuery(cart_section_drawer).find('#product-line-items').append(temp);

                // 	// console.log(temp);
                // });
            },
            complete: function (cart) {
                let final_total = "" + total;
                final_total = final_total.substring(0, final_total.length - 2);
                final_total = final_total
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                cart_section_drawer
                    .find(".cart-total")
                    .html("IDR " + final_total);
                jQuery("body").append(cart_section_drawer);

                setTimeout(function () {
                    jQuery("#cart-panel-custom").removeClass("hide-transition");
                    jQuery("#cart-panel-custom").addClass("active");
                    refreshIndicator();

                    setTimeout(function () {
                        jQuery("#cart-panel-custom").removeClass("active");
                        jQuery("#cart-panel-custom").addClass(
                            "hide-transition"
                        );

                        setTimeout(function () {
                            jQuery("#cart-panel-custom").remove();
                        }, 1000);
                    }, 3000);
                }, 1000);
            },
        });

        setTimeout(function () {
            document
                .getElementsByClassName("cart-panel")[0]
                .classList.remove("active");
            document
                .getElementsByClassName("cart-panel")[0]
                .classList.add("hide-transition");
            //alert('tes32')
        }, 5000);
    }

    $(document).on("click", "#add-to-cart-button", function (e) {
        e.preventDefault();
        e.stopPropagation();

        let form = "";
        let is_notif_form = false;

        if ($(this).closest('form').hasClass('notif-recommendation-form')) {
            form = $(this).closest('form');
            is_notif_form = true;
        }
        else if ($(".in-product-page").hasClass("show")) {
            form = $(".in-product-page");
        } else {
            form = $("#AddToCartForm");
        }

        const wrapper = $('.product-form-wrapper');
        const collections = JSON.parse(wrapper.attr('data-collections') || '[]');

        let variant_id = "";
        let qty = 0;
        
        if (is_notif_form) {
            qty = form.find('input.qty').val();
            variant_id = form.find('input.variant_id').val();
        }
        else {
            qty = form.find("#quantity-input").val();
            form.find('input[name="option-0"]:checked').each(function (i, v) {
                variant_id += $(v).attr("data-variant-id");
            });
        }

        let data = {
            id: variant_id,
            quantity: qty,
        };

        // console.log(data)
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function (item) {
                console.log('added product', item)

                let cart_quantity_indicator = $(
                    "#cart-quantity-indicator"
                ).html();
                if (cart_quantity_indicator == "") {
                    $("#cart-quantity-indicator").show();
                    cart_quantity_indicator = "0";
                }
                cart_quantity_indicator = parseInt(cart_quantity_indicator) + 1;
                $("#cart-quantity-indicator").html(cart_quantity_indicator);

                let size = '';
                let color = '';
                $.each(item.options_with_values, function(i, v) {
                    if (v.name == 'Size') {
                        size = v.value
                    }
                    else if (v.name == 'Color') {
                        color = v.value
                    }
                })

                let item_vendor = item.vendor.replace(/ /g, '+');
                let product_html = `
                <div class="notif-product-image">
                    <img src="${item.image}" alt="${item.product_title}">
                </div>
                <div class="notif-product-content">
                    <div class="notif-product-vendor">
                        <a href="/collections/footwear?filter.p.vendor=${item_vendor}">${item.vendor}</a>
                    </div>
                    <div class="notif-product-title">${item.product_title}</div>
                    <div class="notif-product-options notif-product-color-size">
                        <div class="notif-product-option notif-product-color">
                            <span class="notif-product-label">Color:</span>
                            <span class="notif-product-value">${color}</span>
                        </div>
                        <div class="notif-product-option notif-product-size">
                            <span class="notif-product-label">Color:</span>
                            <span class="notif-product-value">${size}</span>
                        </div>
                    </div>
                    <div class="notif-product-button-list small--hide">
                        <a href="/checkout" class="btn-notif-product">CHECKOUT NOW</a>
                        <button class="btn-notif-product btn-notif-continue btn-close">CONTINUE SHOPPING</button>
                    </div>
                </div>
                <div class="notif-product-button-list medium-up--hide">
                    <a href="/checkout" class="btn-notif-product">CHECKOUT NOW</a>
                    <button class="btn-notif-product btn-notif-continue btn-close">CONTINUE SHOPPING</button>
                </div>
                `

                $('#notif-atc-modal .notif-atc-content-product').html(product_html);

                // pilih koleksi random
                if (collections.length) {
                    const randomCollection = collections[Math.floor(Math.random() * collections.length)];
    
                    // load produk dari koleksi tersebut
                    fetch(`/collections/${randomCollection}/products.json`)
                        .then(res => res.json())
                        .then(data => {                        
                            const products = data.products;
    
                            // ambil 3 produk acak
                            const randomProducts = products
                                .sort(() => 0.5 - Math.random()) // acak urutan array
                                .slice(0, 3); // ambil 3 pertama dari hasil acak
    
                            let recommendation_html = ''
    
                            // loop 3 produk acak
                            randomProducts.forEach(p => {
                                let variant_id = 0;
                                for (variant of p.variants) {
                                    if (variant.available) {
                                        variant_id = variant.id;
                                        break;
                                    }
                                }
    
                                recommendation_html += `
                                <div class="notif-recommendation-item">
                                    <div class="notif-recommendation-image">
                                        <a href="/products/${p.handle}">
                                            <img src="${p.images[0].src}" alt="${p.title}">
                                            <form class="notif-recommendation-form" style="display: none">
                                                <input type="hidden" class="qty" name="qty" value="1">
                                                <input type="hidden" class="variant_id" name="variant_id" value="${variant_id}">
                                                <button type="submit" class="btn-notif-recommendation" id="add-to-cart-button">Add to Bag<button>
                                            </form>
                                        </a>
                                    </div>
                                </div>
                                `
                            });
    
                            $('#notif-atc-modal .notif-recommendation-list').html(recommendation_html)
                        });
                }
                else {
                    $('#notif-atc-modal .notif-atc-recommendation').hide()
                }

                // if (window.matchMedia("(max-width: 750px)").matches) {
                $('body').css('overflow', 'hidden').addClass("menu-opened")
                $("#quickbuy-content .btn-close").trigger("click");

                $("#notif-atc-modal").addClass("show");
                // }

                // timer 6s
                let autoplayDelay = 6000; // 6s
                
                $('.notif-atc-progress-bar .progress-fill').css({'transition': 'none', 'width': '0%'});
                setTimeout(() => {
                    $('.notif-atc-progress-bar .progress-fill').css({'transition': `width ${autoplayDelay}ms linear`, 'width': '100%'});
                }, 100);

                setTimeout(() => {
                    $('html, body').css('overflow', '')
                    $("body").removeClass("menu-opened")

                    $("#notif-atc-modal").removeClass("show");
                }, autoplayDelay + 100)
                // end timer 6s

                renderCartSidebar()
            },
            error: function (responses) {
                console.log(responses);
            },
        });
    });

    function formatMoney(amount, locale, fraction = 2) {
        return new Intl.NumberFormat(locale, {
            style: 'decimal',
            minimumFractionDigits: fraction,
            maximumFractionDigits: fraction
        }).format(amount / 100);
    }

    // cart sidebar
    renderCartSidebar();
    function renderCartSidebar() {
        let product_line_item_str = '<article class="cart-sidebar-product-item"><div class="cart-sidebar-product-image"><img src="" alt=""></div><div class="cart-sidebar-product-content"><div class="cart-sidebar-product-title"><a href="" class="title"></a></div><div class="cart-sidebar-product-variant-price"><div class="cart-sidebar-product-variant"><div class="cart-sidebar-variant-option cart-sidebar-product-color"><div class="cart-sidebar-variant-label">Color</div><div class="cart-sidebar-variant-separator">:</div><div class="cart-sidebar-variant-value"></div></div><div class="cart-sidebar-variant-option cart-sidebar-product-quantity"><div class="cart-sidebar-variant-label">Quantity</div><div class="cart-sidebar-variant-separator">:</div><div class="cart-sidebar-variant-value"></div></div><div class="cart-sidebar-variant-option cart-sidebar-product-size"><div class="cart-sidebar-variant-label">Size</div><div class="cart-sidebar-variant-separator">:</div><div class="cart-sidebar-variant-value"></div></div></div><div class="cart-sidebar-product-price"><div class="cart-sidebar-price cart-sidebar-price-sale"><div class="cart-sidebar-price-label">IDR</div><div class="cart-sidebar-price-value"></div></div><div class="cart-sidebar-price cart-sidebar-price-regular"><div class="cart-sidebar-price-label">IDR</div><div class="cart-sidebar-price-value"></div></div><div class="cart-sidebar-sold-out" style="display:none">Sold Out</div></div></div><div class="cart-sidebar-remove-change"><div class="cart-sidebar-remove">REMOVE [ X ]</div><div class="cart-sidebar-change medium-up--hide" style="display: none">CHANGE</div></div></div></article>'
        let product_line_item = jQuery(product_line_item_str)
        let total = 0

        $.ajax({
            type: 'GET',
            url: '/cart.js',
            cache: false,
            dataType: 'json',
            success: function (cart) {
                $('.cart-sidebar-title .title span').html(cart.item_count)
                
                if (cart.item_count != 0) {
                    $('#cart-quantity-indicator').html(cart.item_count)
                    $('#cart-quantity-indicator').show()

                    $('.cart-sidebar-body').show()
                    $('.cart-sidebar-footer').show()
                    $('.cart-sidebar-empty').hide()

                    $('.cart-sidebar-product-list').html('')

                    $.each(cart.items, function (i, v) {
                        let temp = product_line_item.clone();   

                        $.ajax({
                            type: 'GET',
                            url: `/variants/${v.variant_id}.js`,
                            cache: false,
                            dataType: 'json',
                            success: function (variant) {
                                let variant_price = formatMoney(variant.price, 'en-PH');
                                temp.find('.cart-sidebar-price-regular .cart-sidebar-price-label').html('₱');
                                temp.find('.cart-sidebar-price-regular .cart-sidebar-price-value').html(variant_price);

                                if (variant.price < variant.compare_at_price) {
                                    let variant_compare_at_price = formatMoney(variant.compare_at_price, 'en-PH');
                                    temp.find('.cart-sidebar-price-sale .cart-sidebar-price-label').html('₱');
                                    temp.find('.cart-sidebar-price-sale .cart-sidebar-price-value').html(variant_compare_at_price);
                                }
                                else {
                                    temp.find('.cart-sidebar-price-sale').hide()
                                }

                                let variant_inventory_quantity = variant.inventory_quantity;
                                // let variant_inventory_quantity = 0;

                                if (variant_inventory_quantity == 0) {
                                    temp.find('.cart-sidebar-price').hide()
                                    temp.find('.cart-sidebar-sold-out').show()
                                    temp.find('.cart-sidebar-change').show()
                                }
                            }
                        })

                        temp.attr('data-handle', v.handle);
                        temp.find('.cart-sidebar-product-image img').prop('src', v.featured_image.url);
                        temp.find('.cart-sidebar-product-image img').prop('alt', v.featured_image.alt);
                        temp.find('.cart-sidebar-product-title .title').prop('href', v.url);
                        temp.find('.cart-sidebar-product-title .title').html(v.product_title.toLowerCase());
                        temp.find('.cart-sidebar-product-size .cart-sidebar-variant-value').html(v.options_with_values[0].value);
                        temp.find('.cart-sidebar-product-color .cart-sidebar-variant-value').html(v.options_with_values[1].value.toLowerCase());
                        temp.find('.cart-sidebar-product-quantity .cart-sidebar-variant-value').html(v.quantity);
                        temp.find('.cart-sidebar-remove').attr('data-id', v.key);
                        temp.find('.cart-sidebar-change').attr('data-variant-id', v.id);
                        temp.find('.cart-sidebar-change').attr('data-line-id', v.key);

                        total += v.final_price;
                        $('.cart-sidebar-product-list').append(temp);
                    });

                    let final_total = formatMoney(total, 'en-PH');
                    $('.cart-sidebar-total-price-value').html(final_total)
                }
                else {
                    $('#cart-quantity-indicator').html(cart.item_count)
                    $('#cart-quantity-indicator').hide()

                    $('.cart-sidebar-body').hide()
                    $('.cart-sidebar-footer').hide()
                    $('.cart-sidebar-empty').show()
                }
            }
        });
    }

    $('#cart-button-cta').click(function(e) {
        e.preventDefault()

        $(this).toggleClass('active')
        
        if ($(this).hasClass('active')) {
            $('body').css('overflow', 'hidden').addClass("menu-opened")
            let check_filter = $('.collection-sidebar-panel.hide-mobile') 
            if (check_filter.hasClass('active')) {
                $('.filter-toggle').trigger('click');
                $('#close-container-drawer-filter').attr('aria-sidebar', 'closed')
            }
            $('#atmos-sidebar').attr('aria-sidebar', 'closed')
            $('#new-main-nav-toggle').attr('aria-click', 'false')
            $('#close-container-drawer').attr('aria-sidebar', 'closed')            
            $(".search-panel").removeClass("active");
        }
        else {
            $('html, body').css('overflow', '')
            $("body").removeClass("menu-opened")
        }

        $('.cart-sidebar').toggleClass('show')
    })

    $(document).on('click', '.cart-sidebar-close', function () {
        $('#cart-button-cta').removeClass('active')

        $('html, body').css('overflow', '')
        $("body").removeClass("menu-opened")

        $('.cart-sidebar').removeClass('show')
    })

    $(document).on('click', '.cart-sidebar-remove', function () {
        let line_id = $(this).attr('data-id')

        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                'id': line_id,
                'quantity': 0
            },
            cache: false,
            dataType: 'json',
            success: function () {
                renderCartSidebar()
            }
        })
    })

    function splitStringAndNumber(input) {
        // Hapus spasi di awal/akhir
        input = input.trim();

        // Regex menangkap semua karakter sebelum angka (bisa tanpa spasi) dan angka (bisa desimal)
        const match = input.match(/^([^\d]+?)[\s-]*(\d+(?:\.\d+)?)$/);

        if (match) {
            return [match[1].trim(), match[2]];
        } else {
            return [input, null]; // Jika tidak ditemukan angka
        }
    }

    function convertToSlug(Text) {
        return Text.toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, "");
    }

    function containsOnlyAlphabets(str) {
        return /^[a-zA-Z]+$/.test(str);
    }

    $(document).on('click', '.cart-sidebar-change', function () {
        let product_handle = $(this).closest('.cart-sidebar-product-item').attr('data-handle')
        let current_variant_id = $(this).attr('data-variant-id')
        let current_line_item = $(this).attr('data-line-id')

        console.log('current_variant_id', current_variant_id)

        $.ajax({
            type: 'GET',
            url: window.Shopify.routes.root + `products/${product_handle}.js`,
            cache: false,
            dataType: 'json',
            success: function (product) {
                let product_name = product.title
                let image = product.images[0]
                let vendor = product.vendor
                let vendor_link = `/collections/footwear?filter.p.vendor=${product.vendor}`

                let variant_title = ''
                let variant_qty = 0
                let variant_id = 0
                let inventory = ''
                let availability = ''
                let sku = 0
                let option1 = ''
                let option2 = ''
                let product_size = []

                $('.cart-select-size-modal .product-form__variants').html('')
                $('.cart-select-size-modal .cart-select-swatch').html('')

                $.each(product.variants, function(i, v) {
                    let option_html = `<option value="" data-variant-qty="" data-value="" inventory="" data-name="" data-sku="" data-product-name="" data-image="" data-vendor="" data-vendor-link="" data-option-1="" data-option-2=""></option>`
                    let option_temp = $(option_html).clone();

                    variant_title = v.title
                    variant_qty = v.available ? 1 : 0
                    variant_id = v.id
                    inventory = v.available ? 'enabled' : 'disabled'
                    availability = v.available ? 'available' : 'soldout'
                    sku = v.sku
                    option1 = v.option1
                    option2 = v.option2

                    if (containsOnlyAlphabets(v.option1)) {
                        product_size[0] = ''
                        product_size[1] = v.option1
                    }
                    else {
                        product_size = splitStringAndNumber(v.option1)
                    }

                    option_temp.attr('value', variant_id)
                    option_temp.attr('data-variant-qty', variant_qty)
                    option_temp.attr('data-value', option1)
                    option_temp.attr('data-inventory', inventory)
                    option_temp.attr('inventory', inventory)
                    option_temp.attr('data-name', product_name + ' - ' + variant_title)
                    option_temp.attr('data-sku', sku)
                    option_temp.attr('data-product-name', product_name)
                    option_temp.attr('data-image', image)
                    option_temp.attr('data-vendor', vendor)
                    option_temp.attr('data-vendor-link', vendor_link)
                    option_temp.attr('data-option-1', option1)
                    option_temp.attr('data-option-2', option2)

                    $('.cart-select-size-modal .cart-select-size-flex .size-selected b').html(product_size[0])
                    $('.cart-select-size-modal .product-form__variants').append(option_temp)

                    let swatch_item = `<div class="swatch-element" data-value=""><input type="radio" name="" id="" data-variant-id="" inventory=""><label for=""><span class="swatch-size-label"></span><span class="swatch-size-value"></span></label></div>`
                    let swatch_temp = $(swatch_item).clone();

                    swatch_temp.attr('data-value', option1)
                    swatch_temp.addClass(convertToSlug(option1))
                    swatch_temp.addClass(availability)
                    swatch_temp.find('input').attr('id', `cart-select-swatch-${i}-${convertToSlug(option1)}`)
                    swatch_temp.find('input').attr('name', `cart-select-option-0`)
                    swatch_temp.find('input').attr('data-variant-id', variant_id)
                    swatch_temp.find('input').attr('value', option1)
                    swatch_temp.find('input').attr('inventory', inventory)
                    if (variant_id == current_variant_id) {
                        swatch_temp.find('input').attr('checked', true)
                    }

                    swatch_temp.find('label').attr('for', `cart-select-swatch-${i}-${convertToSlug(option1)}`)
                    swatch_temp.find('.swatch-size-label').html(product_size[0])
                    swatch_temp.find('.swatch-size-value').html(product_size[1])

                    $('.cart-select-size-modal .cart-select-swatch').append(swatch_temp)
                })

                $('.cart-select-add-to-cart').attr('data-variant-id', current_variant_id)
                $('.cart-select-add-to-cart').attr('data-line-id', current_line_item)
                $('.button-notify').attr('data-variant-id', current_variant_id)
                $('.button-notify').attr('data-line-id', current_line_item)

                $('.cart-select-size-modal').addClass('show')
            }
        })
    })

    $(document).on('click', '.cart-select-size-modal .btn-close', function() {
        $(this).closest('.cart-select-size-modal').removeClass('show')
    })

    $(document).on('change', '.swatch.cart-select-swatch :radio', function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        $(this)
            .closest('form')
            .find('.variant-select')
            .eq(optionIndex)
            .val(optionValue)
            .trigger('change');
        
        
        var checked_value = "";
        $('.swatch.cart-select-swatch input:checked').each(function () {
            checked_value += $(this).val() + ' / ';
        });

        var yg_harus_checked = checked_value.replace(/\s*\/\s*$/, "");
        var cari_option = $('.cart-select-product-swatch.product-swatch .product-form__variants option[data-value="'+yg_harus_checked+'"]');
        var inv = cari_option.attr('inventory');
        var product_name = cari_option.attr('data-name');
        var product_sku = cari_option.attr('data-sku');
        var product_name2 = cari_option.attr('data-product-name');
        var product_image = cari_option.attr('data-image');
        var product_vendor = cari_option.attr('data-vendor');
        var product_vendor_link = cari_option.attr('data-vendor-link');
        var product_option1 = cari_option.attr('data-option-1');
        var product_option2 = cari_option.attr('data-option-2');

        let modal = $('.cart-select-size-modal')
        
        if(inv == 'enabled'){
            $(modal).find('.add-to-cart-button').attr('disabled', false);
            $(modal).find('.button-column').show()
            $(modal).find('.bdd-notify-v2').hide()
            $(modal).find('.new-qty').removeClass('soldout')
            $(modal).find('.increase-qty').removeAttr('disabled')
            $(modal).find('.quantity-input').removeAttr('disabled')
            // $(modal).find('.decrease-qty').removeAttr('disabled')
        }
        else{
            $(modal).find('.add-to-cart-button').attr('disabled', true);
            $(modal).find('.button-column').hide()
            $(modal).find('.bdd-notify-v2').show()
            $(modal).find('.new-qty').addClass('soldout')
            $(modal).find('.increase-qty').attr('disabled', true)
            $(modal).find('.quantity-input').attr('disabled', true)
            $(modal).find('.decrease-qty').attr('disabled', true)

            $('.notify-v2-popup__content form').attr('data-size', product_option1);
            $('.notify-v2-popup__content .notify-v2-product-img img').attr('src', product_image);
            $('.notify-v2-popup__content .notify-v2-product-img img').attr('alt', product_name2);
            $('.notify-v2-popup__content .notify-v2-product-vendor').attr('href', product_vendor_link);
            $('.notify-v2-popup__content .notify-v2-product-vendor').html(product_vendor);
            $('.notify-v2-popup__content .notify-v2-product-name').html(product_name2);
            $('.notify-v2-popup__content .notify-v2-product-color .notify-v2-product-option-value').html(product_option2);
            $('.notify-v2-popup__content .notify-v2-product-size .notify-v2-product-option-value').html(product_option1);
            $('.notify-v2-popup__content #product_name').val(product_name);
            $('.notify-v2-popup__content #variant_id').val(cari_option.val());
            $('.notify-v2-popup__content #product_sku').val(product_sku);
        }
    });

    $(document).on('click', '.decrease-qty, .increase-qty', function(e) {
        e.preventDefault();

        let current_qty = parseInt($(".quantity-input").val());
        
        if ($(this).html().trim() == "<span>+</span>") {
            current_qty++;
        } else if ($(this).html().trim() == "<span>-</span>") {
            current_qty = Math.max(current_qty - 1, 0);
        }
        
        if (current_qty <= 1) {
            $(".quantity-input").val(1);
            $(".decrease-qty").attr('disabled', 'disabled');
        } else {
            $(".quantity-input").val(current_qty);
            $(".decrease-qty").removeAttr('disabled');
        }
    })

    $(document).on('click', '.cart-select-add-to-cart', function() {
        let variant_id = $('input[name="cart-select-option-0"]:checked').attr('data-variant-id')
        let quantity = $('input[name="cart-select-quantity"]').val()
        let line_id = $(this).attr('data-line-id')

        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                'id': line_id,
                'quantity': 0
            },
            cache: false,
            dataType: 'json',
            success: function () {
                $.ajax({
                    type: 'POST',
                    url: "/cart/add.js",
                    data: {
                        'id': variant_id,
                        'quantity': quantity
                    },
                    cache: false,
                    dataType: 'json',
                    success: function () {
                        renderCartSidebar()
                        $('.cart-select-size-modal').removeClass('show')
                    }
                })
            }
        })
    })
    // end cart sidebar

    $(document).on("click", "#buy-now", function (e) {
        e.preventDefault();
        let form = "";
        if ($(".in-product-page").hasClass("show")) {
            form = $(".in-product-page");
        } else {
            form = $("#AddToCartForm");
        }

        let variant_id = "";
        let qty = form.find("#quantity-input").val();

        form.find('input[name="option-0"]:checked').each(function (i, v) {
            variant_id += $(v).attr("data-variant-id");
        });

        let data = {
            id: variant_id,
            quantity: qty,
        };

        setTimeout(() => {
            // window.location.href = "/checkout?id=" + variant_id + "&quantity=" + qty;
            window.location.href = `/cart/${variant_id}:${qty}`;
        }, 500);

        // $.ajax({
        // 	type: "POST",
        // 	url: "/cart/add.js",
        // 	data: data,
        // 	dataType: "json",
        // 	success: function () {
        // 		setTimeout(function () {
        // 			window.location.href = "/checkout";
        // 		}, 500);
        // 	},
        // 	error: function (responses) {
        // 		console.log(responses);
        // 	},
        // });
    });
    $(document).on("click", "#shop-gift", function (e) {
        e.preventDefault();
        let form = "";
        if ($(".in-product-page").hasClass("show")) {
            form = $(".in-product-page");
        } else {
            form = $("#AddToCartForm");
        }

        let variant_id = "";
        let qty = form.find("#quantity-input").val();

        form.find('input[name="option-0"]:checked').each(function (i, v) {
            variant_id += $(v).attr("data-variant-id");
        });

        let data = {
            id: variant_id,
            quantity: qty,
            properties: { _description: "product gift" },
        };
        // console.log(data)

        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
                setTimeout(function () {
                    window.location.href = "/cart";
                }, 500);
            },
            error: function (responses) {
                console.log(responses);
            },
        });
    });
    $(document).on("click", "#select-size", function (e) {
        e.preventDefault();
        $("body").addClass("has--popup-dropdown");
        $("#quickbuy-modal").addClass("show");
        $("#quickbuy-modal").addClass("in-product-page");
        $("#quickbuy-content").append($("article.product .product-size-chart"));
        $("#quickbuy-content").append($("article.product .product-swatch:not(.cart-select-product-swatch)"));
        $("#quickbuy-content").append(
            $("article.product .product-qty, article.product .product-button, article.product .product-notify")
        );
        setTimeout(() => {
            $("#quickbuy-content").css("transform", "translateY(0)");
        }, 300);
        $("#quickbuy-content .product-button #buy-now").html("EXPRESS BUY");
        $("#quickbuy-content .product-button #shop-gift").html(
            "NEW! BUY AS A GIFT"
        );
    });

    $(document).on(
        "click",
        ".in-product-page #quickbuy-content .btn-close",
        function () {
            $("body").removeClass("has--popup-dropdown");
            $("#quickbuy-modal").removeClass("show");
            $("#append-back-product").append(
                $(
                    ".product-size-chart, .product-swatch:not(.cart-select-product-swatch), .product-qty, .product-button, .product-notify"
                )
            );
            $("#quickbuy-content .product-button #buy-now").html("BUY NOW");
            $("#quickbuy-content .product-button #shop-gift").html(
                "BUY AS GIFT"
            );
            $("#select-size").show();
            $("#quickbuy-content").css("transform", "");
        }
    );

    $("#quickbuy-modal.in-product-page").click(function (e) {
        if (e.target !== this) return;

        $("body").removeClass("has--popup-dropdown");
        $(this).removeClass("show");
        $("#append-back-product").append(
            $(
                ".product-size-chart, .product-swatch:not(.cart-select-product-swatch), .product-qty, .product-button, .product-notify"
            )
        );
        $("#select-size").show();
    });

    $(document).on("click", ".notif-atc-content .btn-close", function () {
        $('html, body').css('overflow', '')
        $("body").removeClass("menu-opened")

        $("#notif-atc-modal").removeClass("show");
    });

    $(document).on("click", ".notif-atc-content .close-to-buy", function () {
        $('html, body').css('overflow', '')
        $("body").removeClass("menu-opened")

        $("#notif-atc-modal").removeClass("show");
    });

    $("#notif-atc-modal").click(function (e) {
        if (e.target !== this) return;

        $("body").removeClass("has--popup-dropdown");
        $(this).removeClass("show");
    });

    $(".size-chart-toggle").click(function () {
        $("body").removeClass("has--popup-dropdown");
        $("#quickbuy-modal").removeClass("show");
        $("#append-back-product").append(
            $(
                ".product-size-chart, .product-swatch:not(.cart-select-product-swatch), .product-qty, .product-button, .product-notify"
            )
        );
        $("#select-size").show();
        $("#quickbuy-content").css("transform", "");

        $("html, body").animate(
            {
                scrollTop: $(".size-chart.ui-accordion").offset().top - 115,
            },
            1000
        );
        setTimeout(() => {
            let button = $(".new-product-accordion .tab-accordion").eq(2);
            if (!button.hasClass("tab-accordion-active")) {
                button.trigger("click");
            }
        }, 1000);
    });

    $(".toggle-size-chart").click(function () {
        $("html, body").animate(
            {
                scrollTop:
                    $(".new-product-accordion .tab-accordion").eq(2).offset()
                        .top - 77,
            },
            1000
        );
        setTimeout(() => {
            let button = $(".new-product-accordion .tab-accordion").eq(2);
            if (!button.hasClass("tab-accordion-active")) {
                button.trigger("click");
            }
        }, 1000);
    });

    if ($('body').hasClass('template-product')) {
        if (window.matchMedia("(max-width: 640px)").matches) {
            $(window).scroll(function () {
                let position = $('.select-product-mobile-wrapper').position();
                let postion_bottom = position.top + $('.select-product-mobile-wrapper').outerHeight();

                if ($(this).scrollTop() > postion_bottom) {
                    $('.select-product-mobile').addClass('fixed');
                } else {
                    $('.select-product-mobile').removeClass('fixed');
                    
                }
            });
        }
        
    }
})(jQuery);
